import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";

import "./assets/main.css";
import sentry from "./services/sentry";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { faGear } from "@fortawesome/free-solid-svg-icons";
import { useEventStore } from "@/stores/event";

const app = createApp(App);
sentry.init(app);

app.use(createPinia());
app.use(router);

useEventStore().fetchEvent(import.meta.env.VITE_EVENT_SLUG);

library.add(faGear);
app.component("font-awesome-icon", FontAwesomeIcon);

app.mount("#app");
